import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const errorRouter: Array<RouteRecordRaw> = [
    {
        path: '/error',
        component: Layout,
        redirect: '/error/404',
        meta: { title: '错误页面', icon: 'el-icon-s-operation', roles: [], alwaysShow: true },
        children: [
            {
                path: '403',
                name: 'Error403',
                component: () => import('@/views/errorView/403.vue'),
                meta: { title: '403', roles: ['admin'], hasPermission: true }
            },
            {
                path: '404',
                name: 'Error404',
                component: () => import('@/views/errorView/404.vue'),
                meta: { title: '404', roles: ['admin'], hasPermission: true }
            }
        ]
    },{
        path: '/:catchAll(.*)',
        component: Layout,
        redirect: '/error/404',
        children: [],
    }
]

export default errorRouter